import styled from 'styled-components'

export const CloseButton = styled.button`
  border: none;
  align-self: center;
  justify-self: center;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`;

export const JustifyDiv = styled.div`
  p {
    text-align: justify;
  }
`